// Utils
import { toStringWithRoundUp } from "../../../common-utils/number-utils/NumberUtils";
import { formatText } from "../../../common-utils/string-utils/StringUtils";

// Selection Overview Card
export default function SelectionOverviewCard({
  data = [],
  isItemsJustifyBetween = true,
  itemClassName = "mr-2",
}) {
  // items wrapper container style
  const itemsWrapperClassName = isItemsJustifyBetween
    ? "justify-content-between"
    : "";

  return (
    <div className="border p-3 overview-container">
      <div className={`d-flex flex-wrap ${itemsWrapperClassName}`}>
        {data.map((eachData) => {
          const { title, value, isDoStringManipulation = true } = eachData;
          const finalValue = isDoStringManipulation
            ? formatText(toStringWithRoundUp(value))
            : value;

          return (
            <div key={title} className={itemClassName}>
              <h5>{title}</h5>
              <h3 title={finalValue}>{value === 0 ? 0 : finalValue}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
}
